'use client';

import { c as _c } from "react/compiler-runtime";
import './nav-stack-simple.scss';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { NavigationProps } from '@sola/schema/lib/schema.ts';
import { LinkList } from '../../atoms/link-list/link-list.tsx';
type NavStackProps = {
  rootNav: NavigationProps;
  className?: string;
};
export const NavStackSimple: React.FC<NavStackProps> = t0 => {
  const $ = _c(9);
  const {
    rootNav,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("NavStackSimple py-comfy-sm flex flex-col gap-comfy-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rootNav.items) {
    t2 = rootNav.items?.map(_temp);
    $[2] = rootNav.items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex flex-col gap-comfy-sm lg:gap-comfy-xl">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(item) {
  return <div className="px-0" key={item.title}><h2 className="NavStackSimple__title label-md label-amplified py-snug-xl px-comfy-sm lg:px-comfy-xs">{item.title}</h2><LinkList item={item} variant="navigation" useHover={true} className="NavStackSimple__link-list" linkClassName="NavStackSimple__menu-link" /></div>;
}